export default function FlowSection() {
  const steps = [
    {
      number: '01',
      title: 'お問い合わせ',
      description: 'まずはお電話またはお問い合わせフォームからご連絡ください。サービス内容や料金について丁寧にご説明いたします。'
    },
    {
      number: '02',
      title: 'ご相談・ヒアリング',
      description: 'ケアマネージャーと連携し、ご利用者様の状態やご希望を詳しくお伺いします。最適なケアプランをご提案いたします。'
    },
    {
      number: '03',
      title: 'ご契約',
      description: 'サービス内容にご納得いただけましたら、契約手続きを行います。不明な点があれば何でもお尋ねください。'
    },
    {
      number: '04',
      title: 'サービス開始',
      description: '担当ヘルパーがご自宅を訪問し、サービスを開始いたします。初回は特に丁寧にご説明しながら進めます。'
    },
    {
      number: '05',
      title: '定期的な見直し',
      description: 'ご利用者様の状態やご希望の変化に応じて、サービス内容を定期的に見直し、最適なケアを提供し続けます。'
    }
  ];

  return (
    <section className="py-24 bg-gray-50 observe-animation opacity-0">
      <div className="container mx-auto px-6 lg:px-12">
        <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-16 text-center">
          ご利用の流れ
        </h2>

        <div className="max-w-4xl mx-auto space-y-6">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-white rounded-3xl p-8 lg:p-10 shadow-sm hover:shadow-md transition-all duration-300">
                <div className="flex items-start gap-6">
                  <div className="w-16 h-16 bg-cyan-500 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-2xl font-bold text-white">{step.number}</span>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-gray-900 mb-3">
                      {step.title}
                    </h3>
                    <p className="text-gray-700 leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>
              </div>
              
              {index < steps.length - 1 && (
                <div className="flex justify-center py-4">
                  <div className="w-0.5 h-8 bg-cyan-300"></div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
